import { render, staticRenderFns } from "./SchoolSpreadList.vue?vue&type=template&id=5457872c&scoped=true"
import script from "./SchoolSpreadList.vue?vue&type=script&lang=js"
export * from "./SchoolSpreadList.vue?vue&type=script&lang=js"
import style0 from "./SchoolSpreadList.vue?vue&type=style&index=0&id=5457872c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5457872c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5457872c')) {
      api.createRecord('5457872c', component.options)
    } else {
      api.reload('5457872c', component.options)
    }
    module.hot.accept("./SchoolSpreadList.vue?vue&type=template&id=5457872c&scoped=true", function () {
      api.rerender('5457872c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolSpread/SchoolSpreadList.vue"
export default component.exports